module.exports = __webpack_public_path__ + "img/hero-main-back.00dd1bb9.png";